/**
 * beszélget az időpontfoglalóval
 * @author sarkiroka on 2017.09.19.
 */
import axios from 'axios';
import { useI18n } from 'vue-i18n-composable';

export default {
	getTheme(themeId) {
		const { locale } = useI18n();
		return axios.get(`/apps/bookappointment/api/theme/${themeId}`, {
			headers: {
				'Accept-Language': locale.value
			}
		});
	},
	init() {
		return axios.get('/apps/bookappointment/api/appointment/init');
	},
	getAppointment(token) {
		const { locale } = useI18n();
		return axios.get(`/apps/bookappointment/api/appointment/${token}`, {
			headers: {
				'Accept-Language': locale.value
			}
		});
	},
	getAppointmentList(themeId, branchCode) {
		let data = { branchCode, themeId };
		return axios.post('/apps/bookappointment/api/appointment/list', data);
	},
	postReservationForm(data) {
		const { locale } = useI18n();
		return axios.post('/apps/bookappointment/api/personalinformation', data, {
			headers: {
				'Accept-Language': locale.value
			}
		});
	},
	sendTa(data) {
		return axios.post('/apps/bookappointment/api/ta', data);
	}
};
